import { Container } from 'inversify';
import { createContext } from 'react';

export const ProviderContext = createContext<Container | null>(null);
